import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-exclamation-triangle fa-lg mr-3",
  "data-test-ref": "submit-login-help-link-expired-error-icon"
}, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "mr-1" }
const _hoisted_6 = { class: "d-flex justify-content-end my-4" }
const _hoisted_7 = {
  key: 0,
  "data-test-ref": "submit-login-failed-alert"
}
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_11 = ["data-test-ref"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  "data-test-ref": "password-required-message",
  class: "text-danger mt-0"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "invisible" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "d-flex justify-content-between my-4" }
const _hoisted_21 = {
  class: "d-flex align-items-center",
  "data-test-ref": "member-forgot-username-tech-support"
}

import { computed, onMounted, ref } from 'vue';
import { useI18n, createNamespacedT } from '@/i18n';
import { formatPhoneNumber } from '@/utils/format';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { useSiteConfig } from '@/composables/site-config';

import { getSecureAemSiteIdentifier } from '@/utils/aem';

import { useLoginForm } from '@/composables/login-form';
import { createMemberProfileRecoveryService, UserNameOptions } from '@/composables/profile-recovery-service';
import { useAppStore } from '@/store';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-form',
  setup(__props) {

const i18n = useI18n();
const { t } = i18n;
const tNamespace = 'forgotUsername';
const tns = createNamespacedT(i18n, tNamespace);

const ledsService = useLedsService();
const appStore = useAppStore();
const siteConfig = useSiteConfig();
const nonsecureService = useNonsecureService();
const isLinkExpired = ref<boolean>(false);
const recoveryIdentifier = ref<string>(new URLSearchParams(window.location.search).get('recoveryIdentifier') ?? '');
const profileRecoveryService = createMemberProfileRecoveryService({
    ledsService,
    nonsecureService,
});

const {
    username,

    password,
    passwordHasError,
    passwordIsRequired,
    validatePassword,

    loading,

    submissionAlert,

    login,

    forgotUsernameLink,
    forgotPasswordLink,
} = useLoginForm({ aemSiteIdentifier: getSecureAemSiteIdentifier(), usernamePrefilled: true });

const showFailedError = ref(false);

/*--------*\
| Computed |
\*--------*/

const formattedPhoneNumber = computed(() => formatPhoneNumber(tns('techSupport.phoneNumber')));

onMounted(() => {
    getUsername();
});

async function getUsername() {
    loading.value = true;
    try {
        const userNameOptions: UserNameOptions = {
            signal: new AbortController().signal,
            recoveryIdentifier: recoveryIdentifier.value
        };
        const res = await profileRecoveryService.getUsername(userNameOptions);
        if (res.data.username) username.value = res.data.username;
    } catch (axiosError) {
        const errorCode = (axiosError as AxiosError)?.response?.status;
        if (errorCode === 419) {
            isLinkExpired.value = true;
        } else {
            showFailedError.value = true;
        }
    } finally {
        loading.value = false;
    }
}

const navigateToLogin = () => {
    window.location.href = appStore.logoutUrl ?? '';
};

const redirectToUsernameRecovery = () => {
    const aemSiteIdentifier = getSecureAemSiteIdentifier();
    const forgotUserNameUrl = `${forgotUsernameLink.value}&site=${aemSiteIdentifier}`;
    window.location.href = forgotUserNameUrl;
};

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(_unref(tns)('common.title')), 1 /* TEXT */),
    _hoisted_1,
    (isLinkExpired.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_b_alert, {
            variant: "danger",
            show: isLinkExpired.value,
            "data-test-ref": "submit-login-help-link-expired-error-alert"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_i18n_t, {
                      keypath: "forgotUsername.infoForm.alerts.linkExpiredError",
                      tag: "span"
                    }, {
                      recoverYourUsername: _withCtx(() => [
                        _createVNode(_component_b_link, {
                          "data-test-ref": "member-recover-your-username-link",
                          onClick: redirectToUsernameRecovery
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(tns)('infoForm.alerts.recoverYourUsername')), 1 /* TEXT */)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ])
            ], undefined, true),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["show"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_b_button, {
              variant: "primary",
              onClick: navigateToLogin
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(tns)('email.returnToLogin')), 1 /* TEXT */)
              ], undefined, true),
              _: 1 /* STABLE */
            })
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (showFailedError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_b_alert, {
                  variant: "danger",
                  show: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(_unref(tns)('loginForm.failedRetrieveUsername')), 1 /* TEXT */)
                      ])
                    ])
                  ], undefined, true),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(submissionAlert))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                role: "alert",
                "aria-live": "polite",
                "data-test-ref": _unref(submissionAlert).variant === 'danger'
                ? 'submit-login-failed-alert' : 'submit-login-invalid-alert'
              }, [
                _createVNode(_component_b_alert, {
                  variant: _unref(submissionAlert).variant,
                  show: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                        'fa-solid fa-exclamation-triangle pr-2': _unref(submissionAlert)?.variant === 'warning',
                        'fa-solid fa-exclamation-circle pr-2': _unref(submissionAlert)?.variant === 'danger',
                    }),
                      "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    _createVNode(_component_i18n_t, {
                      keypath: _unref(submissionAlert).i18nKey
                    }, {
                      numberOfTries: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(submissionAlert).numberOfTries), 1 /* TEXT */)
                      ]),
                      tries: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(submissionAlert).numberOfTries > 1 ? _unref(tns)('loginForm.tries') : _unref(tns)('loginForm.try')), 1 /* TEXT */)
                      ]),
                      forgotUsername: _withCtx(() => [
                        _createElementVNode("a", { href: _unref(forgotUsernameLink) }, _toDisplayString(_unref(t)('login.link.forgotYourUsername')), 9 /* TEXT, PROPS */, _hoisted_12)
                      ]),
                      forgotPassword: _withCtx(() => [
                        _createElementVNode("a", { href: _unref(forgotPasswordLink) }, _toDisplayString(_unref(t)('login.link.forgotYourPassword')), 9 /* TEXT, PROPS */, _hoisted_13)
                      ]),
                      callSupport: _withCtx(() => [
                        _createElementVNode("a", {
                          href: _unref(t)('login.link.callSupportLink')
                        }, _toDisplayString(_unref(t)('login.link.callSupport')), 9 /* TEXT, PROPS */, _hoisted_14)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["keypath"])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["variant"])
              ], 8 /* PROPS */, _hoisted_11))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_unref(tns)('loginForm.subtext')), 1 /* TEXT */)
          ]),
          _createVNode(_component_b_overlay, {
            show: _unref(loading),
            rounded: "sm"
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "w-100",
                "data-test-ref": "login-form",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(login) && _unref(login)(...args)), ["prevent"]))
              }, [
                _createVNode(_component_b_form_group, {
                  label: _unref(tns)('loginForm.username.label'),
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      "data-test-ref": "username-input",
                      value: _unref(username),
                      class: "bg-primary-light border-primary-light w-50",
                      disabled: "true"
                    }, null, 8 /* PROPS */, ["value"])
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_component_b_form_group, {
                  label: _unref(tns)('loginForm.password.label'),
                  state: _unref(passwordHasError) ? false : null,
                  class: "w-100 mb-0"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_b_form_input, {
                      id: "member-password-input",
                      modelValue: _unref(password),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                      class: "w-50",
                      type: "password",
                      "data-test-ref": "password-input-field",
                      state: _unref(passwordHasError) ? false : null,
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(validatePassword)()))
                    }, null, 8 /* PROPS */, ["modelValue", "state"]), [
                      [_directive_maska]
                    ]),
                    (_unref(passwordHasError) && _unref(passwordIsRequired))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('forgotUsername.loginForm.validations.requiredPassword')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('forgotUsername.loginForm.validations.requiredPassword')), 1 /* TEXT */)
                        ]))
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "state"]),
                _createVNode(_component_b_link, {
                  href: _unref(forgotPasswordLink),
                  class: "mt-0"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('loginForm.forgotPassword')) + "? ", 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_b_link, { onClick: navigateToLogin }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(tns)('common.cancel')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_b_button, {
                    variant: "primary",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(tns)('loginForm.logIn')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ])
              ], 32 /* HYDRATE_EVENTS */)
            ], undefined, true),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["show"]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_i18n_t, {
              keypath: "forgotUsername.techSupport.havingTrouble",
              tag: "p",
              scope: "global"
            }, {
              visitSupport: _withCtx(() => [
                _createVNode(_component_b_link, {
                  "data-test-ref": "member-forgot-username-faq-link",
                  target: "_blank",
                  onClick: _unref(siteConfig).redirectToTechSupport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('techSupport.visitSupport')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              phoneNumber: _withCtx(() => [
                _createVNode(_component_b_link, { "data-test-ref": "member-forgot-password-phone-number" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(formattedPhoneNumber)), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})